@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div
  cdkDrag
  class="popup_main_div add_edit_contact_main_cost select_metter_main_div"
  cdkDragRootElement=".cdk-overlay-pane"
>
  <h2 cdkDragHandle mat-dialog-title class="mat-dialog-header">
    <span>{{ Title }}</span>
    <button class="close-btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content class="mat-typography main">
    <form [formGroup]="costForm">
      <div class="cost-form-grid">
        <div class="label setpadding-bot">Effective Date</div>
        <mat-form-field
          appearance="outline"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.EFFECTIVEDATE),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.EFFECTIVEDATE),
          }"
          class="setpadding-bot"
        >
          <input
            matInput
            [matDatepicker]="picker"
            formControlName="EFFECTIVEDATETEXT"
            (dateChange)="CommencementDate('change', $event)"
          />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        @for (field of costFields; track field) {
          <div class="label">{{ field.label }}</div>
          <mat-form-field appearance="outline">
            <input
              class="sideText"
              matInput
              type="text"
              [formControlName]="field.key"
              [onFormattedChange]="updateCalculations.bind(this)"
              appCurrencyFormat
            />
          </mat-form-field>
        }

        <div class="label setpadding-bot">Total Annual Cost</div>
        <mat-form-field
          appearance="outline"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.TOTALANNUALCOST),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TOTALANNUALCOST),
          }"
          class="setpadding-bot"
        >
          <input class="sideText" matInput formControlName="TOTALANNUALCOST" readonly />
        </mat-form-field>

        <div class="label mt-section">Annual Billing Hours</div>
        <mat-form-field
          appearance="outline"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.ANNUALBILLINGHOURS),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ANNUALBILLINGHOURS),
          }"
        >
          <input class="sideText" matInput type="text" formControlName="ANNUALBILLINGHOURS" />
        </mat-form-field>

        <div class="label">Cost Per Billing Hour</div>
        <mat-form-field
          appearance="outline"
          [ngClass]="{
            'has-error': $safeNavigationMigration(errorWarningData.Error?.COSTPERBILLINGHOUR),
            'has-warning': $safeNavigationMigration(errorWarningData.Warning?.COSTPERBILLINGHOUR),
          }"
        >
          <input class="sideText" matInput formControlName="COSTPERBILLINGHOUR" readonly />
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="popup_ftr justify-end!">
    <button matButton="filled" class="mat-accent" cdkFocusInitial (click)="getCostDetailsData()">
      @if (isspiner) {
        <mat-spinner diameter="24"></mat-spinner>
      }
      {{ btntext }}
    </button>
    <button matButton="tonal" [mat-dialog-close]="false" cdkFocusInitial>Don't Save</button>
  </mat-dialog-actions>
</div>
